module.exports = __webpack_public_path__ + "img/meituan-logo-1fb1bf1d.png";